import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StrongCustomerAuthenticationService } from '@paysafe/paysafe-wallet-saas-web/authentication';
import {
  ScaAuthenticationEventAttemptVerification,
  ScaAuthenticationEventChallengeEmbeddedHybridResponse
} from '@paysafe/paysafe-wallet-saas-web/common';
import { PsCardModule } from '@paysafe-ui/components/card';
import { PsIconComponent } from '@paysafe-ui/components/icon';
import { from } from 'rxjs';

import { ScaConstants } from '../../../constants/sca.const';
import { ScaDetails } from '../../../models/payment/session-payment-response.model';
import { CheckoutErrorHandlerService } from '../../../services/error-handler/checkout-error-handler.service';

@Component({
  selector: 'app-sca-method-selection',
  templateUrl: './sca-method-selection.component.html',
  styleUrls: ['./sca-method-selection.component.scss'],
  standalone: true,
  imports: [CommonModule, PsCardModule, PsIconComponent]
})
export class ScaMethodSelectionComponent {
  @Input() scaDetails: ScaDetails;

  @Output() activeChallenge = new EventEmitter<ScaAuthenticationEventChallengeEmbeddedHybridResponse>();
  @Output() close = new EventEmitter<void>();
  @Output() error = new EventEmitter<void>();

  protected readonly ScaConstants = ScaConstants;

  constructor(private scaService: StrongCustomerAuthenticationService,
              private checkoutErrorHandler: CheckoutErrorHandlerService) {
    // Dependency injection
  }

  onVerificationMethodSelection(verification: ScaAuthenticationEventAttemptVerification): void {
    if (this.isMockScaFlow()) {
      const mockChallenge = {
        eventId: this.scaDetails.eventId,
        walletOperationId: this.scaDetails.walletOperationId,
        verification
      } as ScaAuthenticationEventChallengeEmbeddedHybridResponse;
      this.activeChallenge.emit(mockChallenge);
      return;
    }

    const request = {
      walletOperationId: this.scaDetails.walletOperationId,
      verification
    };
    from(this.scaService.sendScaChallenge(this.scaDetails.eventId, request))
      .subscribe({
        next: (response: ScaAuthenticationEventChallengeEmbeddedHybridResponse) => {
          this.activeChallenge.emit(response);
        },
        error: (error): void => {
          this.checkoutErrorHandler.handleScaError(error, verification.channel);
          this.error.emit();
        }
    });
  }

  onClose(): void {
    this.close.emit();
  }

  private isMockScaFlow(): boolean {
    return this.scaDetails?.eventId?.startsWith('mock-event-') ?? false;
  }
}
